<template>
  <div>
    <a-card class="customer-filter" size="small">
      <fault-task-filter-form v-model="filterForm" @change="onSearch" @reset="handleReset" />
    </a-card>
    <a-card title="跟进任务列表" class="filter-data" size="small">
      <fault-task-data-list :table-data="tableData" :pagination="pagination" :loading="loading" @page-change="handleTableChange" @change="getFaultTaskList" />
    </a-card>
  </div>
</template>

<script>
import { faultTaskList } from '@/api/event/fault';

import FaultTaskFilterForm from '@/pages/event/components/FaultTaskFilterForm';
import FaultTaskDataList from '@/pages/event/components/FaultTaskDataList';

export default {
  name: 'FaultTaskIndex',
  components: {
    FaultTaskFilterForm,
    FaultTaskDataList
  },
  data() {
    return {
      loading: false,
      filterForm: {
        title: null,
        about: 'all',
        time_filter_key: 'created_time'
      },
      pagination: {
        size: 'large',
        total: 0,
        pageSize: this.$store.getters.pageSize,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTotal: total => `共 ${total} 条`
      },
      tableData: []
    };
  },
  mounted() {
    this.getFaultTaskList();
  },
  methods: {
    /**
     * 获取问题列表
     */
    getFaultTaskList() {
      this.loading = true;
      faultTaskList({ ...this.filterForm, page_size: this.pagination.pageSize, page_number: this.pagination.current })
        .then(res => {
          this.tableData = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    handleReset() {
      this.pagination.current = 1;
      this.pagination.pageSize = this.$store.getters.pageSize;
      this.filterForm = {
        time_filter_key: 'created_time'
      };
      this.getFaultTaskList();
    },

    onSearch(filter) {
      this.filterForm = { ...filter };
      this.filterForm.page_number = 1;
      this.getFaultTaskList();
    },

    handleTableChange(pagination) {
      if (pagination.pageSize !== this.pagination.pageSize) {
        pagination.current = 1;
      }
      this.pagination = pagination;
      this.getFaultTaskList();
    }
  }
};
</script>

<style lang="less" scoped>
:deep(.customer-filter) {
  .ant-page-header {
    padding: 0;
  }
  margin-bottom: 16px;
}
</style>
